var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6419 10.3772L8.76445 7.49855L11.654 4.61021C11.8533 4.41096 11.854 4.08796 11.6554 3.88931C11.4569 3.69073 11.1339 3.69127 10.9346 3.89052L8.04506 6.77887L5.16756 3.90019C4.96906 3.7016 4.64607 3.70215 4.44673 3.9014C4.24734 4.10071 4.24666 4.42371 4.44516 4.62229L7.32266 7.50097L4.4332 10.3892C4.2338 10.5886 4.23313 10.9116 4.43163 11.1101C4.6302 11.3088 4.95319 11.3082 5.15259 11.1089L8.04205 8.22065L10.9195 11.0993C11.118 11.2979 11.441 11.2974 11.6404 11.0981C11.8398 10.8988 11.8404 10.5758 11.6419 10.3772Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.277dcdf6fa07e85cbc5c4a135c1736f7.svg";
export { ForwardRef as ReactComponent };